import React, { useContext, useCallback } from "react";

import TablePagination from "@mui/material/TablePagination";

import ListadoContext from "../../../context/ListadoContext";
import { calcularOpcionesPageSize } from "../../ListadoFunciones";

import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";

import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { Typography } from "@mui/material";

function TablePaginationO({
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  count,
  labelRowsPerPage,
  cabeceras,
}) {
  const { opcionesListado, cambiarPagina } = useContext(ListadoContext);
  const paginacion_por_backend = opcionesListado.paginar_backend === "s";

  const calcPagesize = useCallback(() => {
    let size = 10;

    if (opcionesListado.cantdd_registros) {
      size =
        Number(opcionesListado.cantdd_registros) === 0
          ? count
          : Number(opcionesListado.cantdd_registros);
    }

    if (count === 0) {
      size = 0;
    }
    if (count < size) {
      size = count;
    }
    if (
      opcionesListado.cantdd_registros_max &&
      size > opcionesListado.cantdd_registros_max
    ) {
      size = opcionesListado.cantdd_registros_max;
    }
    if (paginacion_por_backend && opcionesListado.paginacion_backend) {
      return opcionesListado.paginacion_backend.perPage;
    }
    return Number(size);
  }, [
    count,
    opcionesListado.cantdd_registros,
    opcionesListado.cantdd_registros_max,
    opcionesListado.paginacion_backend,
    paginacion_por_backend,
  ]);

  const handleChangePage = (event, newPage) => {
    if (paginacion_por_backend) cambiarPagina(newPage, rowsPerPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    if (paginacion_por_backend) {
      // if (e.target.value > opcionesListado.paginacion_backend.perPage) {
      cambiarPagina(page, e.target.value);
      // }
    }
    setRowsPerPage(parseInt(e.target.value, 10));
  };

  if (opcionesListado.paginacion === "n") return <></>;
  if (opcionesListado.consultaEjecutada === "n") return <></>;

  return (
    <tfoot>
      <tr>
        <td colSpan={cabeceras.length} style={{ width: "100%" }}>
          <TablePagination
            sx={{
              "& .MuiTablePagination-selectLabel": {
                margin: "auto",
              },
            }}
            rowsPerPageOptions={calcularOpcionesPageSize(
              calcPagesize(),
              opcionesListado.cantdd_registros_max,
              opcionesListado.cantdd_registros
            )}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelDisplayedRows={({ page, count }) => {
              const totalPages = Math.ceil(count / rowsPerPage);
              return `Pág. ${page + 1} de ${totalPages}`;
            }}
            labelRowsPerPage={labelRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </td>
      </tr>
    </tfoot>
  );
}

export default TablePaginationO;

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  const from = page * rowsPerPage + 1;
  const to = Math.min(count, (page + 1) * rowsPerPage);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5, display: "flex" }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <Typography variant="body2" sx={{ mx: 2, alignSelf: "center" }}>
        {`${from}-${to} de ${count}`}
      </Typography>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}
